import classNames from 'classnames';

import { SelectionCardProps } from './selection-card.type';

export const SelectionCard = ({
  id,
  name,
  value,
  icon,
  title,
  description,
  selected,
  onSelect,
  size = 'l',
  disabled = false,
  className,
  dataTestId,
}: SelectionCardProps) => {
  const testId = dataTestId ?? `selection-card-${id}`;

  return (
    <label
      htmlFor={id}
      data-testid={testId}
      className={classNames(
        'rounded-lg border p-4 shadow-[0px_2px_4px_rgba(0,0,0,0.1)] transition',
        'flex gap-2',
        'peer-focus-visible:ring-2 peer-focus-visible:ring-negative',
        size === 'l' ? 'flex-col items-start justify-center' : 'flex-row items-center',
        selected ? 'bg-accent border-accent-no-bg' : 'bg-primary border-extra-soft',
        disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer',
        className
      )}>
      <input
        id={id}
        name={name}
        value={value}
        type='radio'
        checked={selected}
        disabled={disabled}
        onChange={onSelect}
        className='peer sr-only'
      />
      <div
        aria-hidden='true'
        className={classNames(
          'flex items-center justify-center rounded-[4px] p-2 shrink-0',
          selected ? 'bg-info-inverse text-negative' : 'bg-accent text-info-inverse'
        )}>
        {icon}
      </div>
      <div className='flex flex-col gap-1 p-2'>
        <span className='text-subtitle-m text-primary'>{title}</span>
        {description && <span className='text-body-s text-primary'>{description}</span>}
      </div>
    </label>
  );
};
